import { cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { Text } from '../text';

export interface StatusLabelProps extends CommonProps {
    children?: ReactNode;
}

export const StatusLabelStyles = cva('rounded bg-white py-1 px-2 text-black');

export const StatusLabel = ({
    className,
    children,
    testId = 'status-label',
    ...props
}: StatusLabelProps): JSX.Element => {
    return (
        <Text
            className={twMerge(StatusLabelStyles({ className }))}
            {...props}
            data-testid={testId}
            size="sm"
        >
            {children}
        </Text>
    );
};
